import { html, SYSBaseElement } from "../../../../../../../_ovlclient/src"
import { T } from "../../../../../../../_ovlclient/src/global/globals"
import { ScreenNavigateTo } from "../../../../../../../_ovlclient/src/library/screenapi"

export class CompOrderFeedback extends SYSBaseElement {
  async getUI() {
    const handlePositiveFeedback = (e: Event) => {
      this.actions.app.features.DATFeedback.actions.PreparePositiveFeedback({
        message: T("DATDocumentDataFeedbackDefaultPositive"),
      })

      ScreenNavigateTo("DATFeedback")
    }

    const handleNegativeFeedback = (e: Event) => {
      this.actions.app.features.DATFeedback.actions.PrepareNegativeFeedback({
        message: T("DATDocumentDataFeedbackDefaultNegative"),
      })
      ScreenNavigateTo("DATFeedback")
    }

    const handleDeliveryDateFeedback = (e: Event) => {
      this.actions.app.features.DATFeedback.actions.PrepareDeliveryDateFeedback(
        {
          message: T("DATDocumentDataFeedbackDefaultDeliveryMsg"),
        }
      )
      ScreenNavigateTo("DATFeedback")
    }

    let deliveryFeedback
    if (
      this.state.app.screens.DATOrder.orderDetail.orders[
        this.state.app.screens.DATOrder.orderDetailFormState.selectedOrder
      ].orderType === "own"
    )
      deliveryFeedback = html`
        <div>
          <button
            style="width:100%;"
            @click=${handleDeliveryDateFeedback}
            class="fd-button sap-icon--date-time"
          >
            ${T("DATDocumentDataDeliveryDateFeedback")}
          </button>
        </div>
      `
    return html`
      <div class="fd-layout-panel">
        <div class="fd-layout-panel__header">
          <div class="fd-layout-panel__head">
            <h3 class="fd-layout-panel__title">
              ${T("DATDocumentDataOrderFeedback")}
            </h3>
          </div>
        </div>
        <div class="fd-layout-panel__body">
          <div>
            <button
              style="width:100%;"
              @click=${handlePositiveFeedback}
              class="fd-button fd-button--positive sap-icon--thumb-up"
            >
              ${T("GENPositiveFeedback")}
            </button>
          </div>
          <div>
            <button
              style="width:100%;"
              @click=${handleNegativeFeedback}
              class="fd-button fd-button--negative sap-icon--thumb-down"
            >
              ${T("GENNegativeFeedback")}
            </button>
          </div>
          ${deliveryFeedback}
        </div>
      </div>
    `
  }
}
